import { Box, Button, Container, makeStyles } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

import CssBaseline from "@material-ui/core/CssBaseline";
import { HeaderWithButtons } from "../components-molecules";
import { HttpRegularPut } from "../service";
import { ITheme } from "../constants/theme";
import { RichTextEditor } from "../components-organisms";
import { getAccountDetails } from "../redux/actions/accountDetails";
import { roleName } from "../utils/roles";
import { buttonHoverAndActive, textButtonHoverAndActive } from "../utils/styles/buttonStyles";
import { useTranslation } from 'react-i18next';

export const PrivacyPolicyEdit = (props: any) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const params: any = useParams();
  const [currentData, setCurrentData] = useState("");
  useEffect(() => {
    roleName() === "Merchant" && dispatch(getAccountDetails());
  }, []); // eslint-disable-line
  const data = useSelector((state: any) => state.accountDetails.data);

  const handleSubmit = () => {
    HttpRegularPut("/merchant/returns-policy", {
      Policy: currentData,
      ReturnsWindow: parseInt(params.returnswindow),
    });
    roleName() === "Merchant" &&
      dispatch(
        getAccountDetails(() => {
          history.goBack();
        })
      );
  };

  return (
    <Box className={classes.container}>
      <CssBaseline />

      <Container className={classes.root}>
        <HeaderWithButtons
          smallText={t('merchant.accountSettings')}
          title={t('merchant.privacyPolicy')}
          handleBack={() => {
            history.goBack();
          }}
        ></HeaderWithButtons>
        <div style={{ marginTop: 15 }}>
          <RichTextEditor
            currentData={data?.ReturnsPolicy?.Policy ?? ""}
            onTextChange={(htmlText: string) => setCurrentData(htmlText)}
          />
        </div>
        <div
          style={{
            width: "100%",
            textAlign: "end",
            paddingLeft: props.loading ? "12px" : "16px",
            marginTop: 15,
            marginLeft: "auto",
          }}
        >
          <Button
            variant="contained"
            disableElevation
            className={classes.secondaryButton}
            style={{
              paddingLeft: props.loading ? "12px" : "16px",
              marginRight: 15,
            }}
            onClick={() => history.goBack()}
          >
{t('merchant.cancel')}
          </Button>

          <Button
            variant="contained"
            color="primary"
            disableElevation
            className={classes.primaryButton}
            style={{
              paddingLeft: props.loading ? "12px" : "16px",
            }}
            onClick={handleSubmit}
          >
{t('merchant.submit')}
          </Button>
        </div>
      </Container>
    </Box>
  );
};
const useStyles = makeStyles((theme: ITheme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
  },
  imageList: {
    display: "flex",
    flexDirection: "row",
    marginTop: 15,
    paddingLeft: 0,
  },
  images: {
    width: 200,
    height: 150,
    marginRight: 10,
  },
  submitButton: {
    width: "80px",
    height: "48px",
    borderRadius: "8px",
    padding: "6px 16px",
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
  cancelButton: {
    width: "80px",
    height: "48px",
    borderRadius: "8px",
    padding: "6px 16px",
    backgroundColor: theme.palette.secondary.main,
    marginRight: "8px",
  },
  cssOutlinedInput: {
    display: "flex",
    "&$cssFocused $notchedOutline": {
      border: `1px solid ${theme.palette.primary.main}`,

    },
  },

  cssFocused: {},

  notchedOutline: {
    border: "1px solid rgba(0, 0, 0, 0.12)",
  },
  printButtonText: {
    textTransform: "none",
  },
  root: {
    maxWidth: "840px",
    paddingLeft: 0,
    paddingRight: 0,
  },
  detailsContainer: {
    marginTop: "24px",
    paddingLeft: 0,
    paddingRight: 0,
  },
  printableSection: {
    display: "none",
  },
  primaryButton: {
    borderRadius: "8px",
    marginTop: 15,
    marginLeft: "auto",
    ...buttonHoverAndActive
  },
  secondaryButton: {
    borderRadius: "8px",
    marginTop: 15,
    marginLeft: "auto",
    ...textButtonHoverAndActive
  },
}));
